module.exports = __webpack_public_path__ + "img/target-2-svgrepo-com.a9d92e2f.svg";